// import { AppStateService } from '@/service/app/app-state.service'
import { Injectable, OnDestroy, signal } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { Observable } from 'rxjs'

const DISPLAY_STATE_LOCAL_KEY = 'touCtrlDisplayState'
const PARAMS_LOCAL_KEY = 'touCtrlParams'

export interface StateMachineParams {
  active: boolean
  connect: boolean
  beaconId: number
}

export interface StateMachineSettings {
  pickAutoShow: boolean
  dropAutoShow: boolean
  dropAlertAlgo: boolean
  dropAlertAlgoForce: boolean
  afterDropFocusMap: boolean
}

@Injectable({
  providedIn: 'root',
})
export class TouaregControlStateParamsService implements OnDestroy {
  //private _globalSettingsSubs$: Subscription
  private _defaultSettings: StateMachineSettings = {} as StateMachineSettings

  private readonly _params = signal<StateMachineParams>(
    this.getLocalParams()
  )

  private readonly _settings = signal<StateMachineSettings>(
    this.getLocalSettings()
  )

  // Creation des observables de parametrage
  public readonly paramsSignal = this._params.asReadonly()
  public readonly settingsSignal = this._settings.asReadonly()
  public readonly params$: Observable<StateMachineParams> = toObservable(this._params)
  public readonly settings$: Observable<StateMachineSettings> = toObservable(this._settings)

  public get settings(): StateMachineSettings {
    return this._settings()
  }

  public get params(): StateMachineParams {
    return this._params()
  }

  public get isActive(): boolean {
    return this.params?.active
  }

  constructor() // private _appState: AppStateService
  {
    // On récupère les paramètre globaux
    /*     this._globalSettingsSubs$ = this._appState.globalSettings$
      .pipe(
        pluck('umap_config.json', 'touaregControllerOptions', 'defaultSettings')
      )
      .subscribe((settings) => {
        this._defaultSettings = settings || {}
        const local = this._storage.get(DISPLAY_STATE_LOCAL_KEY) || {}
        this._settings.next({ ...settings, ...local })
      }) */
  }

  private _storageGet<T>(key: string): T | undefined {
    const raw = localStorage.getItem(key)
    if (!raw) return undefined
    try {
      return JSON.parse(raw) as T
    } catch {
      return undefined
    }
  }

  private _storageSet(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value))
  }

  public setLocalSettings(display: any) {
    const currentParams = this._settings()
    const mergedParams = { ...currentParams, ...display }
    this._settings.set(mergedParams)
    this._storageSet(DISPLAY_STATE_LOCAL_KEY, mergedParams)
  }

  public getLocalSettings(): StateMachineSettings {
    const local = this._storageGet<Partial<StateMachineSettings>>(DISPLAY_STATE_LOCAL_KEY) || {}
    return { ...this._defaultSettings, ...local }
  }

  public setLocalParams(params: any) {
    const currentParams = this._params()
    const mergedParams = { ...currentParams, ...params }
    this._params.set(mergedParams)
    this._storageSet(PARAMS_LOCAL_KEY, mergedParams)
  }

  public getLocalParams(): StateMachineParams {
    return this._storageGet<StateMachineParams>(PARAMS_LOCAL_KEY) || ({} as StateMachineParams)
  }

  ngOnDestroy() {
    //if (!!this._globalSettingsSubs$) this._globalSettingsSubs$.unsubscribe()
  }
}
